import { jsx as _jsx } from "preact/jsx-runtime";
import { useState } from 'preact/hooks';
import { isPerksWalletEligible, perksWalletButtonText, savePerksWalletOffer, usesPwaasSave, } from '../utils/perksWallet';
export function PerksWallet({ offer, settings, styles, userAttributes, additionalStyles, }) {
    const [isSaving, setIsSaving] = useState(false);
    const [isSaved, setIsSaved] = useState(offer.alreadySaved || false);
    if (!isPerksWalletEligible(offer, settings, userAttributes)) {
        return null;
    }
    const buttonStyles = {
        background: 'transparent',
        border: 'none',
        borderRadius: '4px',
        padding: '0px',
        fontSize: '12px',
        fontWeight: 600,
        cursor: isSaved ? 'default' : 'pointer',
        color: 'black',
        textDecoration: 'underline',
        fontFamily: styles.offerText?.font || 'Roboto, sans-serif',
        opacity: isSaved ? 0.7 : 1,
        ...additionalStyles,
    };
    const handleSaveOffer = async () => {
        if (isSaved || isSaving)
            return;
        /** Only the PWAAS path is in-page and awaitable, so only it shows "Saving…". */
        const isPwaas = usesPwaasSave(settings, userAttributes);
        if (isPwaas) {
            setIsSaving(true);
        }
        const result = await savePerksWalletOffer(offer, settings, userAttributes);
        if (result === 'saved') {
            setIsSaved(true);
        }
        if (isPwaas) {
            setIsSaving(false);
        }
    };
    const buttonText = perksWalletButtonText(settings, isSaving ? 'saving' : isSaved ? 'saved' : 'idle');
    return (_jsx("button", { id: 'ms_perksWallet', style: buttonStyles, onClick: e => {
            e.stopPropagation();
            handleSaveOffer();
        }, disabled: isSaved, children: buttonText }));
}
